import {Signal} from '@angular/core';
import {
  FeedbackAnswerUpdateRequest,
  FeedbackAnswerUpdateResource,
  FeedbackAttemptStateResource,
  FeedbackFormPresentationResource,
  FileStorageResource,
} from '../types/generated';
import {FeedbackAttemptResultResource} from '../types/generated/feedbackAttemptResultResource';
import {FeedbackAttemptContext} from '../types/feedback-types/feedbackAttemptContext.interface';
import {FeedbackAttemptNavigationTarget} from '../types/feedback-types/feedbackAttemptNavigationTarget.interface';
import {Observable} from 'rxjs';

export abstract class FeedbackAttemptFacade {
  public abstract readonly attemptContext: Signal<FeedbackAttemptContext | null>;
  public abstract readonly attemptLockTokens: Signal<Record<string, string>>;
  public abstract readonly attemptReadonlyLocks: Signal<Record<string, boolean>>;

  public abstract enterAttempt(instanceId: number): Observable<FeedbackAttemptStateResource>;
  public abstract loadAttemptPresentation(formId: number): Observable<FeedbackFormPresentationResource>;
  public abstract lockAttempt(attemptId: number): Observable<string | null>;
  public abstract unlockAttempt(attemptId: number): Observable<void>;
  public abstract unlockAttemptOnUnload(attemptId: number): Observable<void>;
  public abstract updateAttemptAnswer(
    attemptId: number,
    questionId: number,
    body: FeedbackAnswerUpdateRequest
  ): Observable<FeedbackAnswerUpdateResource>;
  public abstract uploadAttemptAnswerFile(
    attemptId: number,
    questionId: number,
    file: File
  ): Observable<FileStorageResource>;
  public abstract detachAttemptAnswerFile(
    attemptId: number,
    questionId: number,
    fileUuid: string
  ): Observable<void>;
  public abstract submitAttempt(attemptId: number, autoSubmitted?: boolean): Observable<FeedbackAttemptResultResource>;
  public abstract setAttemptValidationErrors(questionIds: number[]): void;
  public abstract isPublicAttempt(): boolean;
  public abstract getBackNavigationTarget(): FeedbackAttemptNavigationTarget;
  public abstract getCompletionNavigationTarget(instanceId: number): FeedbackAttemptNavigationTarget;
  public abstract getAttemptBrowserUrl(instanceId: number): string;
}
